"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var color_1 = __importDefault(require("color"));
var styles = function (theme) {
    return (0, styles_1.makeStyles)({
        box: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(3),
            borderRadius: 5,
            backgroundColor: (0, color_1.default)(theme.palette.common.black)
                .alpha(0.04)
                .rgb()
                .string()
        },
        icon: {
            fontSize: 70,
            alignSelf: 'center'
        },
        iconSuccess: {
            color: theme.palette.success.main
        },
        iconError: {
            color: theme.palette.error.main
        },
        gotoText: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3),
            textAlign: 'center'
        },
        button: {
            width: 'auto',
            display: 'block',
            margin: "".concat(theme.spacing(3), "px auto")
        }
    });
};
exports.default = styles;
//# sourceMappingURL=PasswordResetSuccessStyle.js.map